import { render, staticRenderFns } from "./faceAuth.vue?vue&type=template&id=6b9f7b86&scoped=true"
import script from "./faceAuth.vue?vue&type=script&lang=js"
export * from "./faceAuth.vue?vue&type=script&lang=js"
import style0 from "./faceAuth.vue?vue&type=style&index=0&id=6b9f7b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9f7b86",
  null
  
)

export default component.exports